// extracted by mini-css-extract-plugin
module.exports = {"viewerContainer":"xmlviewer_viewerContainer__2xsoh","xmlViewerXslt":"xmlviewer_xmlViewerXslt__3y6iU","MuiAppBar-colorPrimary":"xmlviewer_MuiAppBar-colorPrimary__1sdJg"};